var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckboxi = function SvgCheckboxi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "M4.41 21h15.18A1.41 1.41 0 0 0 21 19.59V4.41A1.41 1.41 0 0 0 19.59 3H4.41A1.41 1.41 0 0 0 3 4.41v15.18A1.41 1.41 0 0 0 4.41 21"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.466 12.924 2.424 2.172a.8.8 0 0 0 1.068 0l5.576-5a.8.8 0 1 0-1.068-1.192l-5.042 4.522-1.89-1.694a.8.8 0 1 0-1.068 1.192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.08,
    d: "M19.59 21A1.41 1.41 0 0 0 21 19.59V4.41A1.41 1.41 0 0 0 19.59 3H4.41A1.41 1.41 0 0 0 3 4.41v15.18A1.41 1.41 0 0 0 4.41 21zm0-1.4H4.41L4.4 4.41l15.19-.01.01 15.19z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckboxi);
export default ForwardRef;